import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard, FolderKanban, Briefcase, Handshake, Truck, ClipboardList,
  Wallet, Users, Settings,
} from 'lucide-react';

export interface NavTopItem {
  label: string;
  icon: LucideIcon;
  to: string;
  requiredPermission: string | null;
}

/**
 * Flat single links only, per explicit feedback that the mega-menu
 * dropdowns were too much - every module link now goes to that
 * module's own hub/dashboard page (HR, Finance, and Logistics &
 * Travel already work this way: a landing page with clickable cards
 * to every sub-area, avoiding a deep header menu entirely). System
 * Setup is a new hub page separating platform configuration
 * (accounts, roles, org structure, audit) from People/HR (managing
 * staff as employees) - previously these were confusingly nested
 * together under one "People" menu.
 */
export const navTopItems: NavTopItem[] = [
  { label: 'Home', icon: LayoutDashboard, to: '/', requiredPermission: null },
  { label: 'Programmes', icon: FolderKanban, to: '/programmes', requiredPermission: 'programmes.view' },
  { label: 'Projects', icon: Briefcase, to: '/projects', requiredPermission: 'projects.view' },
  { label: 'Partners', icon: Handshake, to: '/partners-hub', requiredPermission: 'partner.due_diligence.view' },
  { label: 'Logistics & Travel', icon: Truck, to: '/logistics-travel', requiredPermission: 'travel.view_own' },
  { label: 'MEAL', icon: ClipboardList, to: '/vcollect', requiredPermission: 'vcollect.project.view' },
  { label: 'Finance', icon: Wallet, to: '/finance', requiredPermission: 'finance.dashboard.view' },
  { label: 'HR', icon: Users, to: '/hr', requiredPermission: 'employees.manage' },
  { label: 'System Setup', icon: Settings, to: '/admin', requiredPermission: 'admin.users.view' },
];
